/**
 * GOOGLE PLACES AUTOCOMPLETE ADDRESS FIELD VALIDATOR
 */
import ErrorMessages from '@mymyTranslations/validation';
export default {
    params: ['addressProperties', 'requireStreetNumber'],
    computesRequired: true,
    validate: ( value, args ) => {

        // no latitude or longitude means Google's API call was not successful
        if (! args.addressProperties.latitude || ! args.addressProperties.longitude) {
            return {
                required: true,
                valid: false,
            };
        }

        // if a street is required, make sure the name and number are present
        if (args.requireStreetNumber === true && ! args.addressProperties.streetNumber) {
            return {
                required: true,
                valid: false,
            };
        }

        // the input is valid
        return {
            required: true,
            valid: true,
        };;
    },

    // error message
    message: (fieldName, args) => {
        let key = args.requireStreetNumber === true ? 'googleAddressStreetNumber' : 'googleAddressPostalCode';
        return ErrorMessages[window.mymy.request.currentSite.language].messages[key];
    },
};